import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface OtrosTramitesHeaderProps {
  onCreate: () => void;
}

export const OtrosTramitesHeader: React.FC<OtrosTramitesHeaderProps> = ({ onCreate }) => (
  <section className="rounded-xl border border-gray-100 bg-white p-4 sm:p-6 shadow-sm">
    <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">Gestión de Otros Trámites</h1>
        <p className="text-sm text-gray-500">Certificaciones, Poderes, Autorizaciones y más</p>
      </div>
      <Button
        size="lg"
        className="self-start md:self-center"
        onClick={onCreate}
      >
        <Plus className="h-5 w-5" />
        Nuevo Trámite
      </Button>
    </div>
  </section>
);
